import { RouteTrajectoryApi, RouteTrajectory } from '../models';

export function mapRouteTrajectoryApiToModel(
  routeTrajectoryApi: RouteTrajectoryApi
): RouteTrajectory {
  return {
    trajectory: routeTrajectoryApi.trajectory,
  };
}

